import { IDocumento } from "../../interfaces/IDocumento";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { enums } from "../../enums/enums";

export const MAX_DOCUMENTOS_RETORNO = 20;

export const clonarDocumentosCliente = (documentos?: IDocumento[]): IDocumento[] =>
    (documentos ?? []).map(d => ({ ...d }));

export const esServicioRetornoDocumentos = (servicio: ServicioAdicional): boolean =>
    servicio.id === enums.servicioAdicional.retornoDocumentos
    || servicio.esRetornoDocumentos === true;

export const retornoDocumentosSeleccionadoInvalido = (servicio: ServicioAdicional): boolean => {
    if (!servicio.esRetornoDocumentos || !servicio.seleccionado) {
        return false;
    }
    if (!servicio.documentos?.length) {
        return true;
    }
    if (servicio.documentos[0]?.documento === "") {
        return true;
    }
    return false;
};

export const documentosInicialesRetorno = (
    servicio: ServicioAdicional,
    documentosCliente: IDocumento[]
): IDocumento[] => {
    if (servicio.documentos?.length) {
        return servicio.documentos.map(d => ({ ...d }));
    }
    return clonarDocumentosCliente(documentosCliente);
};

export const construirFilasDocumentosPorCantidad = (
    cantidad: number,
    documentosActuales: IDocumento[],
    documentosCliente: IDocumento[]
): IDocumento[] => {
    const totalDocumentosCliente = documentosCliente.length;
    let total = totalDocumentosCliente > cantidad ? totalDocumentosCliente : cantidad;
    if (total > MAX_DOCUMENTOS_RETORNO) {
        total = MAX_DOCUMENTOS_RETORNO;
    }
    const filas: IDocumento[] = [];
    for (let i = 0; i < total; i++) {
        const existeDocumento = i < documentosActuales.length;
        filas.push({
            id: i + 1,
            clienteDocumentoID: existeDocumento
                ? documentosActuales[i].clienteDocumentoID
                : 0,
            documento: existeDocumento ? documentosActuales[i].documento : "",
            descripcion: existeDocumento
                ? documentosActuales[i].descripcion
                : (documentosCliente[i]?.descripcion ?? "")
        });
    }
    return filas;
};
